import { IAuthUser, IProfileUser, Roles } from '../../interfaces/src'
import { isEnableForFeatureLeadManagement } from './isEnableForFeatures'
import { getMacrobolsaUser } from '../../apis-ssr/utils/macrobolsa/get-macrobolsa-user-status-client'

export const portalSectionValidator = (
  profile: IProfileUser,
  roles: Roles,
  authUser: IAuthUser | null
): Map<string, { name: string; rule: boolean; id: string }> => {
  const { hasMacrobolsaNotAdvancedUser } = getMacrobolsaUser()
  const hasRoles = Object.keys(roles).length > 0
  // eslint-disable-next-line @shopify/prefer-module-scope-constants
  const ROLDEVELOPER =
    roles?.DEVELOPER || roles?.ROLE_ADMIN_DEVELOPER
      ? Boolean(authUser?.isSelectDevelop)
      : false
  const basic = hasRoles && profile?.verified && !ROLDEVELOPER
  const brokerBasic = hasRoles && !roles?.ASSOCIATION && !ROLDEVELOPER

  const rulesNames: Map<string, { name: string; rule: boolean; id: string }> =
    new Map([
      [
        'home',
        {
          id: 'home',
          name: 'Inicio',
          rule: Boolean(brokerBasic)
        }
      ],
      [
        'search',
        {
          id: 'search',
          name: 'Buscador',
          rule: Boolean(brokerBasic)
        }
      ],
      [
        'development-searcher',
        {
          id: 'development-searcher',
          name: 'Buscar desarrollos',
          rule: Boolean(brokerBasic)
        }
      ],
      [
        'lists',
        {
          id: 'lists',
          name: 'Listas',
          rule: Boolean(brokerBasic && !hasMacrobolsaNotAdvancedUser)
        }
      ],
      [
        'my-properties',
        {
          id: 'my-properties',
          name: 'Propiedades',
          rule: Boolean(brokerBasic)
        }
      ],
      [
        'lead-management',
        {
          id: 'lead-management',
          name: 'Tablero de seguimiento',
          rule: Boolean(
            brokerBasic && isEnableForFeatureLeadManagement(profile)
          )
        }
      ],
      [
        'crm',
        {
          id: 'crm',
          name: 'CRM',
          rule: Boolean(
            brokerBasic && !isEnableForFeatureLeadManagement(profile)
          )
        }
      ],
      [
        'requirements',
        {
          id: 'requirements',
          name: 'Requerimientos',
          rule: Boolean(brokerBasic)
        }
      ],
      [
        'manage-platforms',
        {
          id: 'manage-platforms',
          name: 'Vinculaciones',
          rule: Boolean(
            hasRoles &&
              (roles?.AGENCY || !roles?.AGENCY_BROKER) &&
              profile?.verified &&
              !roles?.ASSOCIATION &&
              !ROLDEVELOPER &&
              !hasMacrobolsaNotAdvancedUser
          )
        }
      ],
      [
        'site-web',
        {
          id: 'site-web',
          name: 'Sitio web',
          rule:
            Boolean(
              Boolean(
                !ROLDEVELOPER &&
                  ((brokerBasic && !roles?.AGENCY_BROKER) || roles?.AGENCY)
              ) || roles?.ASSOCIATION
            ) && !hasMacrobolsaNotAdvancedUser
        }
      ],
      [
        'association-reports',
        {
          id: 'association-reports',
          name: 'Reportes',
          rule: Boolean(roles?.ASSOCIATION)
        }
      ],
      [
        'association-agencies',
        {
          id: 'association-agencies',
          name: 'Inmobiliarias',
          rule: Boolean(roles?.ASSOCIATION)
        }
      ],
      [
        'association-properties',
        {
          id: 'association-properties',
          name: 'Propiedades',
          rule: Boolean(roles?.ASSOCIATION)
        }
      ],
      [
        'association-brokers',
        {
          id: 'association-brokers',
          name: 'Asesores',
          rule: Boolean(roles?.ASSOCIATION)
        }
      ],
      [
        'shop',
        {
          id: 'shop',
          name: 'Tienda',
          rule: Boolean(basic)
        }
      ],
      [
        'appraisals',
        {
          id: 'appraisals',
          name: 'Estimación de valor',
          rule: Boolean(hasRoles && !ROLDEVELOPER && !roles?.ASSOCIATION)
        }
      ],
      [
        'contacts',
        {
          id: 'contacts',
          name: 'Contactos',
          rule: Boolean(
            hasRoles &&
              !ROLDEVELOPER &&
              !roles?.ASSOCIATION &&
              !hasMacrobolsaNotAdvancedUser
          )
        }
      ]
    ])

  return rulesNames
}
